import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useStoreUIV2 } from '../../hooks/useStore.hook';
import { Icon, IconType } from '../icon/icon.component';
import { Popover } from '../popover/popover.component';
import { Text } from '../text/text.component';
import './switchApp.component.scss';

export declare namespace SwitchAppType {
  type Props = {
    className?: string | null;
  };
}

export const SwitchApp = observer(({ className }: SwitchAppType.Props) => {
  const { SSOStore } = useStoreUIV2();

  return (
    <nav className={classNames(`switchApp`, className)}>
      <Popover
        triggerElement={<Icon variant="module" color={'deep_indigo_50'} />}
        withPadding={false}
      >
        <div className="switchApp__body">
          {SSOStore?.resources?.modules
            .filter(({ url }) => !url?.startsWith(window.location.origin))
            .sort((a, b) => a.label.localeCompare(b.label))
            .map(
              ({
                name,
                label,
                url,
                canUse,
                color,
                description,
                title,
                logo,
              }) => (
                <div
                  onClick={() => canUse && window.location.replace(url)}
                  key={name}
                  className={`switchApp__body__item ${canUse ? 'switchApp__body__item--active' : 'switchApp__body__app--inactive'}`}
                >
                  <Icon
                    size="xs"
                    variant={logo as IconType.Props['variant']}
                    color={'black_90'}
                  />
                  <Text color={'black_70'} variant="body">
                    {label}
                  </Text>
                </div>
              ),
            )}
        </div>
      </Popover>
    </nav>
  );
});
